import { Addon } from './cms_shared_types';

export interface ProductListActions {
  add: (newProduct: Product) => Promise<void>;
  addMultiple: (newProducts: Product[]) => Promise<void>;
  replace: (newProduct: Product) => Promise<void>;
  remove: (index: number) => Promise<void>;
  removeByCodes: (codes: string[]) => Promise<void>;
  reset: () => void;
}

export interface Product {
  name: string;
  code: string;
  quantity: string;
  timeQuantity: string;
  musicClass: string;
  priceYearInclVat: number; // price per month
  priceYearExclVat: number; // price per month
  schablonQuantity?: string;
  schablonTimeQuantity?: string;
  startDate?: string;
  endDate?: string;
  _timeQuantitySelection?: string;
}

export interface AddonListActions {
  add: (newAddon: Addon) => void;
  replace: (oldAddon: Addon, newAddon: Addon) => void;
  remove: (index: number) => void;
  reset: () => void;
}

export enum Steps {
  PRODUCT_FAMILY,
  PRODUCT_CHOICE,
  SUMMARY,
  ADDONS,
  INFORMATION,
  INVOICE,
  CONTACT,
  SIGNING_PAGE,
  LANDING_PAGE,
}
